/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React helper functions
import pxToRem from '../../functions/pxToRem';

declare module '@mui/material/SvgIcon' {
    interface SvgIconPropsSizeOverrides {
        xsmall: true;
        xlarge: true;
    }
}

export default {
    defaultProps: {
        fontSize: 'inherit',
    },

    variants: [
        {
            props: { fontSize: 'xsmall' },
            style: {
                fontSize: pxToRem(16),
            },
        },
    ],

    styleOverrides: {
        fontSizeInherit: {
            fontSize: 'inherit !important',
        },

        fontSizeXsmall: {
            fontSize: `${pxToRem(16)} !important`,
        },

        fontSizeSmall: {
            fontSize: `${pxToRem(20)} !important`,
        },

        fontSizeMedium: {
            fontSize: `${pxToRem(24)} !important`,
        },

        fontSizeLarge: {
            fontSize: `${pxToRem(36)} !important`,
        },
        fontSizeXLarge: {
            fontSize: `${pxToRem(48)} !important`,
        },
    },
};
